import underscore from 'underscore'

export default ((message) => {
    if (!message) return ''

    if (message.embedly) {
        return message.embedly
    } else if (message.content) {
        return _.truncate(message.content, {'length': 30, 'separator': /,? +/})
    } else if (message.hasOwnProperty('file')) {
        let file_type = message.file.file_type.indexOf('image') !== -1 ? `an image` : `a file`;
        return `${message.sender.name} sent ${file_type}.`
    }
})

